import React from 'react';
import PropTypes from 'prop-types';
import Loading from 'components/Loading/Loading';
import { Overlay, TitleText, SubtitleText } from './styled';

const BlockingOverlay = ({ isVisible, title, subtitle }) => {
  if (!isVisible) {
    return null;
  }

  return (
    <Overlay aria-busy="true" aria-live="polite">
      <Loading
        text={
          <>
            <TitleText>{title}</TitleText>
            {subtitle && <SubtitleText>{subtitle}</SubtitleText>}
          </>
        }
        size="3rem"
      />
    </Overlay>
  );
};

BlockingOverlay.propTypes = {
  isVisible: PropTypes.bool,
  title: PropTypes.node,
  subtitle: PropTypes.node,
};

BlockingOverlay.defaultProps = {
  isVisible: false,
  title: null,
  subtitle: null,
};

export default BlockingOverlay;
